/**
 *
 * Material UI styles for ReduxFormFieldCheckbox
 *
 *
 * @see https://material-ui.com/styles/basics
 *
 */

const styles = theme => ({
  checkboxRoot: {
    position: 'relative',
  },
  error: {
    bottom: theme.spacing(-3),
    position: 'absolute',
    right: 0,
  },
});

export default styles;
